import { Capacitor } from "@capacitor/core";

const platform = Capacitor.getPlatform();
const isMobile = platform === "ios" || platform === "android";

export const getSessionStorage = () => {
  return isMobile ? localStorage : sessionStorage;
};

export const setSessionItem = (key: string, value: string) => {
  getSessionStorage().setItem(key, value);
};

export const getSessionItem = (key: string) => {
  return getSessionStorage().getItem(key);
};

export const removeSessionItem = (key: string) => {
  getSessionStorage().removeItem(key);
};
